import { ViewChatRecipient } from '@app/core/async-services/http/versioned/interfaces/chat.interface';
import { API } from '@app/core/models';
import { createAction, props } from '@ngrx/store';
import { MessageModels } from '../../../interfaces';

export const loadContacts = createAction('[Message] Load Contacts');

export const loadContactsSuccess = createAction(
  '[Message] Load Contacts Success',
  props<{ response: API.ChatContactsSuccess }>(),
);

export const loadContactsFailure = createAction(
  '[Message] Load Contacts Failure',
  props<{ response: API.Response }>(),
);

export const addRecipient = createAction(
  '[Message] Add Recipient',
  props<{ contact: MessageModels.ContactVM }>(),
);

export const removeRecipient = createAction(
  '[Message] Remove Recipient',
  props<{ index: number }>(),
);

export const clearRecipients = createAction('[Message] Clear Recipients');

export const selectPeopleNext = createAction('[Message] Select People Next');

export const getChatChannelForUsersFailure = createAction(
  '[Message] Get Chat Channel For Users Failure',
  props<API.Response>(),
);

export const getChatChannelForUsersSuccessChannelExists = createAction(
  '[Message] Get Chat Channel For Users Success Channel Exists',
  props<{ channel: string }>(),
);

export const getChatChannelForUsersSuccessChannelDoesNotExist = createAction(
  '[Message] Get Chat Channel For Users Success Channel Does Not Exist',
);

export const sendFirstMessage = createAction(
  '[Message] Send First Message',
  props<{ message: string; secureUrls: string[] }>(),
);

export const sendFirstMessageSuccess = createAction(
  '[Message] Send First Message Success',
  props<{ channel: string }>(),
);

export const createChatChannelForUsersSuccess = createAction(
  '[Message] Creat Chat Channel For Users Success',
  props<{ channel: string; message: string; secureUrls: string[] }>(),
);

export const addPeopleToChat = createAction(
  '[Message] Add People To Chat',
  props<{
    currentRecipients: ViewChatRecipient[];
  }>(),
);
